import ua from 'express-useragent';
import absoluteUrl from 'next-absolute-url';
import nookies from 'nookies';

export function makeLMSCtx(ctx: NextPageContext) {
  const cookies = nookies.get(ctx);
  const { host } = absoluteUrl(ctx.req);
  let [subdomain] = host.split('.');
  if (host.includes('builds.opticpwr.dev')) {
    subdomain = process.env.NEXT_PUBLIC_STAGING_SUBDOMAIN;
  }
  const env = makeLmsEnv(host);
  const device = makeDevice(ctx);

  const referer = ctx.req?.headers?.referer ?? null;
  const protocol = (referer && referer.split(host)[0]) || env.isDev ? 'http://' : 'https://';
  const url = protocol + host;
  const tenant = { subdomain, url, urlMobile: url + '/mobile' };

  return { env, cookies, tenant, device };
}

function makeDevice(ctx: NextPageContext) {
  const headers = ctx.req?.headers ?? null;
  if (!headers) return null;
  const { isDesktop, isTablet, isMobile, browser, version, os, platform, source } = ua.parse(headers['user-agent']);
  return { isDesktop, isTablet, isMobile, browser, version, os, platform, source };
}

function makeLmsEnv(host: string) {
  const isDev = host.includes(':');
  const isStaging = !isDev && host.includes('.stg.');
  const isProduction = !isStaging;
  return { isDev, isStaging, isProduction };
}
